var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_407",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29245",
    "data-name": "Group 29245",
    transform: "translate(509 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -509, -10837)",
    filter: "url(#Ellipse_407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407-2",
    "data-name": "Ellipse 407",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50226",
    "data-name": "Path 50226",
    d: "M31.736,12.994h-1.4a12.709,12.709,0,0,1-3.742-.535A17.369,17.369,0,0,1,29.13,7.515l.668-.869-1.069-.2a18.877,18.877,0,0,0-1.938-.134,15.53,15.53,0,0,0-3.942.4,37.047,37.047,0,0,1-.468-4.41V1.635h-.668c-1.67,0-4.209,1.871-5.279,2.673C15.3,3.239,12.693.9,11.089.9l-.067.067h-.668v.668A21.3,21.3,0,0,1,9.82,6.312a30.359,30.359,0,0,1-5.212-.468l-.935-.2.134.935a16.647,16.647,0,0,0,2.138,6.014,15.71,15.71,0,0,0-4.276,2.539l-.668.6.735.535c1.069.735,1.8,1.27,2.405,1.67.668.4.668.668,1.2,1.136A14.792,14.792,0,0,1,2.6,21.146l-.869.535.935.6,3.007,1.737c-.067.4-.267,1.069-.468,2.606l-.2,1.069s4.009-.668,6.014-2H21.713c.6.267,2.673,2,4.544,2h.8l-.2-.8c-.267-1.136-.4-1.8-.468-2.2.935-.6,3.608-2.272,4.276-3.675l.4-.668-.735-.2a7.922,7.922,0,0,1-2.272-1.069A15.053,15.053,0,0,0,31.4,14Z",
    transform: "translate(-488.868 -10819.801)",
    fill: "#81d4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50227",
    "data-name": "Path 50227",
    d: "M26.372,28a2.673,2.673,0,1,0,2.673,2.673A2.673,2.673,0,0,0,26.372,28Zm-14.7,0a2.673,2.673,0,1,0,2.673,2.673A2.673,2.673,0,0,0,11.673,28Z",
    transform: "translate(-491.523 -10828.793)",
    fill: "#bcaaa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50228",
    "data-name": "Path 50228",
    d: "M20.35,11C16.274,11,13,14.608,13,19.82v6.348c0,5.279,3.274,8.887,7.35,8.887s7.35-3.608,7.35-8.82V19.887C27.7,14.608,24.426,11,20.35,11Z",
    transform: "translate(-492.85 -10823.152)",
    fill: "#d7ccc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50229",
    "data-name": "Path 50229",
    d: "M23.076,37H19v.6c0,.8.334,1.67,1.069,1.8.067.8.468,1.6,1.27,1.6s1.2-.8,1.336-1.6c.468-.134,1-.6,1-1.8V37Z",
    transform: "translate(-494.841 -10831.78)",
    fill: "#43a047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50230",
    "data-name": "Path 50230",
    d: "M16.681,37.971a.642.642,0,0,1-.6-.468.7.7,0,0,1,.4-.869,17.181,17.181,0,0,1,4.878-.735,14.789,14.789,0,0,1,4.878.735.676.676,0,1,1-.468,1.27,16.964,16.964,0,0,0-8.953,0C16.814,37.971,16.747,37.971,16.681,37.971Z",
    transform: "translate(-493.858 -10831.415)",
    fill: "#8d6e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50231",
    "data-name": "Path 50231",
    d: "M22,26v3.007c0,.735.067,3.007,1.336,3.007s1.336-2.272,1.336-3.007V26Z",
    transform: "translate(-495.837 -10828.13)",
    fill: "#efebe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50232",
    "data-name": "Path 50232",
    d: "M27.007,21a3.007,3.007,0,1,0,3.007,3.007A3.007,3.007,0,0,0,27.007,21Z",
    transform: "translate(-496.5 -10826.471)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50233",
    "data-name": "Path 50233",
    d: "M18.007,21a3.007,3.007,0,1,0,3.007,3.007A3.007,3.007,0,0,0,18.007,21Z",
    transform: "translate(-493.514 -10826.471)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28957",
    "data-name": "Group 28957",
    transform: "translate(-476.509 -10803.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50234",
    "data-name": "Path 50234",
    d: "M25.35,24a.668.668,0,1,0,.668.668A.668.668,0,0,0,25.35,24Zm-6.682.668a.668.668,0,1,0,.668.668A.668.668,0,0,0,18.668,24.668Z",
    transform: "translate(-18 -24)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28958",
    "data-name": "Group 28958",
    transform: "translate(-478.527 -10806.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50235",
    "data-name": "Path 50235",
    d: "M21.007,21.027a9.114,9.114,0,0,1-2.472-.4,6.632,6.632,0,0,0-1-.2,5.963,5.963,0,0,0-1.737,0,.687.687,0,0,1-.8-.468.726.726,0,0,1,.468-.8,7.128,7.128,0,0,1,2.272,0,9.111,9.111,0,0,1,1.136.267,7.075,7.075,0,0,0,2.071.334,10.316,10.316,0,0,0,2.071-.334,9.111,9.111,0,0,1,1.136-.267,7.128,7.128,0,0,1,2.272,0,.609.609,0,0,1,.468.8.687.687,0,0,1-.8.468,5.963,5.963,0,0,0-1.737,0q-.4.1-1,.2A7.372,7.372,0,0,1,21.007,21.027Z",
    transform: "translate(-14.981 -19.067)",
    fill: "#64b5f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRick);
export default __webpack_public_path__ + "static/media/rick.e24ef78574d9da2b5a916717558544a0.svg";
export { ForwardRef as ReactComponent };